/**
 * Returns keypress event handler that will be triggered only on specific key presses
 * @param {Object} keyHandlersMap - Map of keyboard keys to event handlers
 * @returns {Function}
 */
const keyPressListener = (keyHandlersMap) => (e) => {
    const handler = keyHandlersMap[e.key];
    handler && handler(e);
};

export default keyPressListener;
